import React from 'react';
import { SiMedium } from 'react-icons/si';

const blogConfig = [
  {
    id: 'blog-0',
    title: 'J Cole',
    links: [
      {
        name: 'article',
        url: 'https://medium.com/@oscar.g.perales',
        icon: <SiMedium />,
      },
    ],
    image:
      'https://www.jagurltv.com/wp-content/uploads/2020/08/DA7AF74F-6596-45A2-8E02-DFA7E49C6C70.jpeg',
    description: 'Test',
    target: '_blank',
  },
];

export default blogConfig;
